import React from 'react';

export const Footer = () => {
    return <div className="dr-footer">
        <ul>
            <li>&copy; 1999 – 2020 "Draugas.lt"</li>
            <li><a href="/ppolitika.cfm">Privatumo politika</a></li>
            <li><a href="/ntaisykles.cfm">Naudojimosi taisyklės</a></li>
            <li><a href="/reklama.cfm">Reklama</a></li>
            <li><a href="/kontaktai.cfm">Kontaktai</a></li>
        </ul>
    </div>;
}